var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"uploaded-image-preview"},_vm._l((_vm.images),function(image){return _c('inline-image',{key:("upload-image-preview-" + (image.src)),attrs:{"src":image.src,"alt":image.alt},on:{"delete":_vm.handleDelete}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }